import React from "react"
import { QuickSendSelectionKind } from "../types/preferredGift"
import { ProductSelection } from "./ProductSelection"
import type { QuickSendSelectionItem } from "~/src/types/productSelection"

const quickSendSelectionInput = (item: QuickSendSelectionItem, index: number) => {
  const { id } = item
  if (id) {
    return <input type="hidden" value={id} name={`quick_send[selections_attributes][${index}][id]`} />
  }
}

const kindInput = (item: QuickSendSelectionItem, index: number) => {
  const { id, kind } = item
  if (kind && kind != QuickSendSelectionKind.None) {
    return <input type="hidden" value={kind} name={`quick_send[selections_attributes][${index}][kind]`} />
  } else if (id) {
    return <input type="hidden" value="1" name={`quick_send[selections_attributes][${index}][_destroy]`} />
  }
}

export function QuickSendEditSelectionInputs() {
  const userSelection = ProductSelection.useSelectedItems<QuickSendSelectionItem>()

  const selectedItems = Object.values(userSelection).filter(
    ({ id, kind }) => id || (!!kind && kind != QuickSendSelectionKind.None)
  )

  return (
    <>
      {selectedItems.map((item, index) => {
        const { selectedVariant, selectable } = item
        const { id, type } = selectable

        return (
          <div key={`storeProductInput${id}`}>
            {quickSendSelectionInput(item, index)}
            {kindInput(item, index)}
            <input type="hidden" value={id} name={`quick_send[selections_attributes][${index}][selectable_id]`} />
            <input type="hidden" value={type} name={`quick_send[selections_attributes][${index}][selectable_type]`} />
            {selectedVariant ? (
              <input
                type="hidden"
                value={selectedVariant?.id}
                name={`quick_send[selections_attributes][${index}][selected_variant_id]`}
              />
            ) : (
              <></>
            )}
          </div>
        )
      })}
      <input name="step" type="hidden" defaultValue="selections" />
    </>
  )
}
